var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "個人情報保護方針",
        "append-to-body": true,
        width: "783px",
        top: "100px",
        visible: _vm.isVisible,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.isVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "content", staticStyle: { "font-size": "12px" } },
        [
          _c("section", [
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _vm._v(
                  "D’litE3-X including all webpages, domains, sub-domains, and subparts (the “Portal”) is provided by BASF (hereinafter referred to as “us” or “we” or “our”). This privacy policy (the “Privacy Policy”) applies to our websites, mobile applications and other online services that link to this Privacy Policy (the “Services”), which are available on or through the Portal maintained by BASF. This Privacy Policy describes how BASF collects, uses, stores and shares personal information gathered via our websites and any related or successor sites, and any mobile versions of these sites (collectively, the “Website”). We refer to the visitors of the Website as users (“Users” or “you”)."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("section", [
            _c("h3", [_vm._v("A. Handling of personal data")]),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _vm._v(
                  "In the following, we would like to inform you about how we handle personal data when you use this Service. Unless otherwise stated in the following sections, the legal basis for handling your personal data results from the necessity of data handling in order to provide the Service and the functionalities requested by you and for invoicing purposes. We also process data from the Service for other business purposes of the BASF Group, such as for the further development, production, and/or marketing of our products and services (including statistical purposes and for the continual improvement of our offers; in these cases, processing is carried out exclusively on an anonymous basis so that personal data cannot be traced back to you)."
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _vm._v(
                  "If you use our Service, your browser transfers certain data to our webserver for technical purposes in order to provide you with the information you have called up. In order to enable the use of the Service, the following data are collected, stored in the short-term, and used: In order to safeguard our legitimate interests, we also store such data for a limited time so that we may derive personal data in the event of unauthorized access or attempted access to the local server."
                )
              ]
            ),
            _vm._v(" "),
            _c("section", [
              _c("h4", [_vm._v("1. Registration and login")]),
              _vm._v(" "),
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "In order to use full functionalities of our Service, you may first register with a user account. You can set your personal login details at a later login. When you register and login later, we process the following information about you:"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _c("p", [_vm._v("•\tFirst name and surname")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "•\tContact details (including email address and telephone number for queries), "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("•\tUsername and password")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "•\tLog data about your logins, including time stamp"
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "We process these data in order to enable your access to our Service or improve and optimize our service experience and safeguard your account security. The permission of using camera or photo album will be granted only after your approval. The data are automatically deleted upon deactivation of your user account."
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("section", [
              _c("h4", [_vm._v("2. Use of cookies")]),
              _vm._v(" "),
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "We will inform you about using cookies in our cookie banner when you visit our website. You accept the use of cookies by further using our website. A Cookie is a neutral technology that enables a website server to store data on your device or to read data from your device. The Cookie assigned to you is unique and the content of it is usually encrypted. Cookies notify us when you sign into our services so that we can authenticate your identity to ensure the security of your account. Cookies help us to protect the security of our data and services, and to detect cheating, hacker and fraudulent activities against our products or services."
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "We will not use cookies outside of the scope of this Data Privacy Statement. You may adjust your preferences and submit your choice to either enable or disable cookies. You may use your browser settings to decide which cookies to accept and to decline. You can erase all the cookies by clearing your cache. But please be aware that you may not be able to enjoy the best service experience, some services also may not work properly if you decline cookies."
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("section", [
              _c("h4", [_vm._v("3. Information security measures")]),
              _vm._v(" "),
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "We will safeguard the security of information with various security protection measures within the reasonable security level, including encryption techniques, anonymization and special management systems, processes and organizations. We endeavor to safeguard the information security of the user to prevent the information from loss, improper use, unauthorized access or disclosure. "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "D’litE3-X uses encryption technologies such as Secure Sockets Layer (SSL) via HTTPS ciphertext to secure the security of data transmission. The personal data of Users will be fully protected by the aforesaid data server from leaking to any unauthorized third party. We will strictly limit the personnel who can access the information and check their fulfillment of the confidentiality obligation."
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("section", [
              _c("h4", [_vm._v("4. Online behavioural tracking")]),
              _vm._v(" "),
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "When you use D’litE3-X services, we will collect the following information to provide you with D’litE3-X services, maintain normal running of our services, improve and optimize our service experience and safeguard your account security: Device information including device model, operating system, unique device identifier; device location information such as login IP address; D’litE3-X version number; and log information including manner, type and status of the network accessed, network quality data, operation log and service log information. All the information collected will only be used for providing D’litE3-X services, and not being disclosed to any unauthorized third-party. "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("section", [
              _c("h4", [
                _vm._v(
                  "5. In accordance with relevant laws and regulations as well as the national standards, we may collect and use, without your authorization and consent, your personal information:\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _c("p", [
                    _vm._v(
                      "• That is directly related to the national interests such as national security and defense security as well as significant public interests such as public security, public health and public knowledge;"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "• That is directly related to crime investigation, prosecution, trial and execution of judgment;"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "• For the purpose of maintaining your or any other individual's life, property and other significant legal interests, but it is difficult to obtain your own consent;"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "• That is made available to the social public by you on your own;"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "• From legally and publicly disclosed information, such as legal news reports, published government information and other channels;"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "• That is necessary for your request for execution and performance of the contract;"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "• Which is necessary for maintaining secure and stable running of the products or services provided, such as discovering and disposing troubles in the products or services; and"
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "• In other circumstances specified in the laws and regulations."
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("section", [
              _c("h4", [_vm._v("6. Information storage")]),
              _vm._v(" "),
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "Place of Information Storage: We will store within China the personal information collected and produced within China as provided for in the laws and regulations.\n          Period of Information Storage: In general, we will retain your personal information only for so long as is necessary to realize the purpose. For example, if you want to use D’litE3-X services, we will store your mobile phone number data in order to enable your access to our Service. The data are automatically deleted upon deactivation of your user account. When you sent out comments, we will store the corresponding information in order to enable your use of comment feature. We will delete the corresponding information when you deleted your comments.\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "In case of halt of our products or services, we will notify you of the same by the means of push notification or announcement, delete or anonymize your personal information within the reasonable period, immediately discontinue the activity of collecting your personal information and close the third-party application service interfaces to prevent third-party services from collecting and further using your personal information."
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("section", [
            _c("h3", [_vm._v("B. Information on your rights")]),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _vm._v(
                  "You may exercise the following rights based on the applicable data protection laws:"
                )
              ]
            ),
            _vm._v(" "),
            _c("section", [
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "1.\tThe right of access to personal data about you that have been saved;"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _c("p", [
                    _vm._v("1)  enter D’litE3-X，click “User Center”;")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("2)  click “My Profile”;")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("section", [
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "2.\tThe right to rectification, to erasure or to restriction of processing your personal data;"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _c("p", [
                    _vm._v("1)   enter D’litE3-X，click “User Center”;")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("2)   click “My Profile”;")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("3)   change the name and phone；")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("4)   confirm after editing；")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("section", [
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "3.\tThe right to lodge a complaint: when you have complaints, please contact us via email "
                  ),
                  _c("a", { attrs: { href: "javascript:void(0)" } }, [
                    _vm._v("CS.DlitE3-X@basf.com. ")
                  ]),
                  _vm._v(
                    "We will review the issues involved as soon as possible and give you the reply within fifteen days upon verification of your identity."
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("section", [
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "4.\tThe right to object to processing that does not serve our legitimate interests, public interest or profiling, unless we can demonstrate compelling legitimate grounds for the processing which override your interests, rights and freedoms or for the establishment, exercise or defense of legal claims;"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("section", [
              _c(
                "p",
                { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
                [
                  _vm._v(
                    "5.\tYou may revoke the consent you gave to the collection, storage, processing, use and transfer of your personal data at any time with effect for the future. For more information on this, please view the respective sections above in which data processing on the basis on your consent is described."
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _vm._v(
                  "If you wish to exercise your rights, please address your request to the contact person listed below."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("section", [
            _c("h3", [_vm._v("C. Contact details")]),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _vm._v(
                  "If you have any concerns regarding data protection, please contact our Group Data Protection Officer at the following address: Group Data Protection Officer Ms Alexandra Haug EU Data Protection Officer 67056 Ludwigshafen, Germany +49 (0) 621 60-0 Email: "
                ),
                _c("a", { attrs: { href: "javascript:void(0)" } }, [
                  _vm._v("data-protection.eu@basf.com")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("section", [
            _c("h3", [_vm._v("D. Adjustments to the Data Privacy Policy")]),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [
                _vm._v(
                  "We reserve the right to update this Data Privacy Policy from time to time. Any updates to this Data Privacy Policy shall be published on our Website. Amendments apply as soon as they are published on our Website. We therefore recommend that you visit our Website regularly so that, if necessary, you can keep yourself informed of any updates."
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { margin: "1em 0", "line-height": "1.5em" } },
              [_vm._v("Last updated: [2020-6-22]")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.isVisible = false
                }
              }
            },
            [_vm._v("確定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b082692a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b082692a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/agreement/Prjp.vue
// module id = null
// module chunks = 